import { render, staticRenderFns } from "./AdminSessionReview.vue?vue&type=template&id=54a222c2&scoped=true&"
import script from "./AdminSessionReview.vue?vue&type=script&lang=js&"
export * from "./AdminSessionReview.vue?vue&type=script&lang=js&"
import style0 from "./AdminSessionReview.vue?vue&type=style&index=0&id=54a222c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a222c2",
  null
  
)

export default component.exports